import { ENUMBER_TYPES } from "@constants";
import { IUserDetailsInfo } from "../../interface/IUserDetails";

interface IEmailResponse {
    email: string;
    type?: string;
    validated?: boolean;
}

interface IPhoneNumberResponse {
    id: number;
    phoneNumber: string;
    type: ENUMBER_TYPES;
}

export interface IUserContactResponse {
    emails: IEmailResponse[];
    phoneNumbers: IPhoneNumberResponse[];
    firstName: string;
    lastName: string;
    identityDocument: string;
    canEditIdentityDocument: boolean;
}

export const getResponseToState = (response: IUserContactResponse): IUserDetailsInfo => ({
    email: response.emails.length ? response.emails[0].email : "",
    phoneNumber: response.phoneNumbers.length ? findMobileNumber(response.phoneNumbers) : "",
    firstName: response.firstName,
    lastName: response.lastName,
    identityDocument: response.identityDocument,
    canEditIdentityDocument: response.canEditIdentityDocument,
});

const findMobileNumber = (phoneNumbers: IPhoneNumberResponse[]): string => {
    const mobileNumber: IPhoneNumberResponse | undefined = phoneNumbers.find((num) => num.type === "MOBILE");
    return mobileNumber ? mobileNumber.phoneNumber : "";
};
